import React, { Fragment, useState, useEffect, useCallback } from "react";
import {
  CardHeader,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";
import { MdSave, MdDelete } from "react-icons/md";
import { showSweetAlert } from "../../Common/SweetAlert";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RiDeleteBinLine } from "react-icons/ri";
import AddTechnicalskill from "./AddTechnicalskill";
import {
  deleteMainSkillRequest,
  resetData,
  addMainSkillRequest,
} from "../../../redux/jobseeker/main_skill/actions";
import {
  updateCandidatePrimarySkillsRequest,
  resetCandidateUpdateState,
} from "../../../redux/recruiter/update_candidate_primary_skill/actions";
import Select from "react-select";
import { ratingOptions, passingyearsOptions } from "../../../Constant";
import { fetchSkillsRequest } from "../../../redux/mandatorySkills/actions";
import { showToast } from "../../Common/Toast";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import { extractAfterLastHyphen, handleNumberInput } from "../../Common/CommonFunction";
import { FiPlusSquare } from "react-icons/fi";
import { generatePassingYearsOptions } from "../../../Constant";

const TechnicalskillsModal = ({ profileData, validationMessages }) => {
  const dispatch = useDispatch();
  const { cand_id, jobcad_id, type } = useParams();
  const [editedSkills, setEditedSkills] = useState({});
  const [errors, setErrors] = useState({});
  const [showNewSkillForm, setShowNewSkillForm] = useState(false);
  const skillsReducerData = useSelector(
    (state) => state.mandatorySkillsReducer
  );
  const skillsData = skillsReducerData.data?.data || [];

  // Validate function applied only to skill and experience fields
  const validate = () => {
    let errors = {};
    let isValid = true;

    // Loop through all skills to validate skill and experience fields
    Object.keys(editedSkills).forEach((skillId) => {
      const skill = editedSkills[skillId];

      // Validate IT skill
      if (!skill.it_skill) {
        errors[`${skillId}_it_skill`] = "Skill is required";
        isValid = false;
      }


      if (skill.skill_last_used) {
        const dobYear = new Date(profileData.jobseeker_date_of_birth).getFullYear();
        const skillLastUsed = parseInt(skill.skill_last_used.value, 10); // assuming it's a {label, value} object

        if (skillLastUsed < dobYear) {
          errors[`${skillId}_skill_last_used`] = "Last used year cannot be before Date of Birth";
          isValid = false;
        }
      }



      if (formData.skill_last_used) {
        const dobYear = new Date(profileData.jobseeker_date_of_birth).getFullYear();
        const skillLastUsed = parseInt(formData.skill_last_used.value, 10);

        console.log("passingYear", skillLastUsed, "dobYear", dobYear);

        if (skillLastUsed < dobYear) {
          errors.skill_last_used = "Last Used year cannot be before Date of Birth";
          isValid = false;
        }
      }
    });

    setErrors(errors);
    return isValid;
  };

  const handleSaveClick = (skillId) => {
    if (!validate()) {
      return; // Prevent save if validation fails
    }

    const updatedSkill = {
      id: skillId,
      ...editedSkills[skillId],
    };
    const formattedData = {
      id: updatedSkill.id,
      seeker_id: cand_id,
      it_skill: updatedSkill.it_skill?.value || "",
      skill_last_used: updatedSkill.skill_last_used?.value || "",
      skill_version: updatedSkill.skill_version,
      skill_rating: updatedSkill.skill_rating?.value || "",
      skill_experienced: updatedSkill.skill_experienced,
    };
    dispatch(addMainSkillRequest(formattedData));
  };

  const handleChange = (skillId, e) => {
    const { name, value } = e.target;

    // Clear the error for the specific field when the user starts typing
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (updatedErrors[`${skillId}_${name}`]) {
        delete updatedErrors[`${skillId}_${name}`];
      }
      return updatedErrors;
    });

    setEditedSkills({
      ...editedSkills,
      [skillId]: {
        ...editedSkills[skillId],
        [name]: value,
      },
    });
  };

  const handleDeleteClick = (skill) => {
    showSweetAlert("confirm", {
      message: "You want to delete this skill?",
      fun: handleDeleteTechnicalSkills,
      id: skill,
    });
  };

  const handleDeleteTechnicalSkills = (skill) => {
    dispatch(
      deleteMainSkillRequest({ id: skill.id, seeker_id: skill.seeker_id })
    );
  };

  const handleSkillChange = (skillId, e) => {
    setEditedSkills({
      ...editedSkills,
      [skillId]: {
        ...editedSkills[skillId],
        it_skill: e,
      },
    });
  };

  const handleSkillRatingChange = (skillId, selectedOption) => {
    setEditedSkills((prevSkills) => ({
      ...prevSkills,
      [skillId]: {
        ...prevSkills[skillId],
        skill_rating: selectedOption,
      },
    }));
  };

  const handleSkillLastUsedChange = (skillId, selectedOption) => {
    setEditedSkills({
      ...editedSkills,
      [skillId]: {
        ...editedSkills[skillId],
        skill_last_used: selectedOption,
      },
    });
  };

  const handleSkillsFocus = () => {
    const fetchData = async () => {
      try {
        const keyword = "";
        dispatch(fetchSkillsRequest(keyword, "MANDATORY"));
      } catch (error) { }
    };
    fetchData();
  };

  const handleSkillsInputChange = useCallback(
    (inputValue) => {
      const fetchData = async () => {
        try {
          dispatch(fetchSkillsRequest(inputValue, "MANDATORY"));
        } catch (error) { }
      };
      fetchData();
    },
    [dispatch]
  );

  useEffect(() => {
    if (profileData && profileData.it_skills) {
      const initialSkills = profileData.it_skills.reduce((acc, skill) => {
        acc[skill.id] = {
          ...skill,
          skill_last_used: skill.skill_last_used
            ? passingyearsOptions.find(
              (option) => option.value == skill.skill_last_used
            )
            : null,
          skill_rating: skill.skill_rating
            ? ratingOptions.find((option) => option.value == skill.skill_rating)
            : null,
        };
        return acc;
      }, {});
      setEditedSkills(initialSkills);
    }
  }, [profileData]);

  const addMainSkillReducerData = useSelector(
    (state) => state.mainSkillReducer
  );

  useEffect(() => {
    if (
      addMainSkillReducerData.status &&
      addMainSkillReducerData.message !== ""
    ) {
      showToast("success", addMainSkillReducerData.message);
      dispatch(
        fetchJobseekerDataRequest({
          seeker_id: cand_id,
          job_cand_id: jobcad_id,
        })
      );
      dispatch(resetData());
    } else if (
      addMainSkillReducerData.status === false &&
      addMainSkillReducerData.message !== ""
    ) {
      showToast("error", addMainSkillReducerData.message);
      dispatch(
        fetchJobseekerDataRequest({
          seeker_id: cand_id,
          job_cand_id: jobcad_id,
        })
      );
      dispatch(resetData());
    }
  }, [dispatch, addMainSkillReducerData]);

  const updateCandidatePrimarySkillReducerData = useSelector(
    (state) => state.updateCandidatePrimarySkillReducer
  );

  useEffect(() => {
    if (
      updateCandidatePrimarySkillReducerData.status &&
      updateCandidatePrimarySkillReducerData.message != ""
    ) {
      showToast("success", updateCandidatePrimarySkillReducerData.message);
      dispatch(
        fetchJobseekerDataRequest({
          seeker_id: extractAfterLastHyphen(cand_id),
          job_cand_id: extractAfterLastHyphen(jobcad_id),
        })
      );
      dispatch(resetCandidateUpdateState());
    } else if (
      updateCandidatePrimarySkillReducerData.status == false &&
      updateCandidatePrimarySkillReducerData.message != ""
    ) {
      showToast("error", updateCandidatePrimarySkillReducerData.message);
      dispatch(resetCandidateUpdateState());
    }
  }, [updateCandidatePrimarySkillReducerData]);

  const handleCoreSkillsChange = (selectedOptions) => {
    const updatedErrors = { ...errors, core_skills: "" };
    setFormData((prevFormData) => ({
      ...prevFormData,
      core_skills: selectedOptions,
    }));
  };

  const handleCoreSkillsSubmit = (event) => {
    event.preventDefault();

    const formattedData = {
      primary_skill: formData.core_skills.map((loc) => loc.value).join(","),
    };
    console.log("formattedData", formattedData);
    dispatch(updateCandidatePrimarySkillsRequest(formattedData));
  };

  const [formData, setFormData] = useState({
    core_skills: profileData.primary_skill ? profileData.primary_skill : null,
  });

  const [showValidationMessages, setValidationMessages] = useState();
  useEffect(() => {
    // Check if validationMessages is an object with the errors
    if (validationMessages && typeof validationMessages === "object") {
      setValidationMessages(validationMessages);
      console.log("validationMessages888", validationMessages);
    }
  }, [validationMessages]);

  return (
    <div className="mt-3">
      <CardHeader className="py-3">
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="mb-0" style={{ fontWeight: 550 }}>
            Main Skills
          </h4>
          <FiPlusSquare
            className={`add-icon ${profileData.it_skills && profileData.it_skills.length > 15
              ? "text-muted disabled"
              : ""
              }`}
            size={22}
            onClick={() => setShowNewSkillForm(true)} // Show new skill form
            title="Add"
          />
        </div>
      </CardHeader>
      <CardBody>
        <div className="ps-2 ">
          {showValidationMessages && (
            <div className="text-danger mb-4">
              {showValidationMessages.skills}
            </div>
          )}
          {showNewSkillForm && (
            <AddTechnicalskill dob={profileData.jobseeker_date_of_birth} onClose={() => setShowNewSkillForm(false)} />
          )}
          {profileData &&
            profileData.it_skills &&
            profileData.it_skills.length > 0 ? (
            <Fragment>
              {profileData.it_skills.map((skill) => (
                <Row key={skill.id} className="mb-3">
                  <Col md={12}>
                    <FormGroup>
                      <Label>Skill </Label>
                      <span className="text-danger">*</span>
                      <Select
                        options={skillsData}
                        value={editedSkills[skill.id]?.it_skill || null}
                        onChange={(e) => handleSkillChange(skill.id, e)}
                        onFocus={handleSkillsFocus}
                        onInputChange={handleSkillsInputChange}
                        placeholder="Select skill"
                      />
                      {errors[`${skill.id}_it_skill`] && (
                        <div className="text-danger">
                          {errors[`${skill.id}_it_skill`]}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>
                        Experience (In Months)
                        <span className="text-danger">*</span>
                      </Label>
                      <input
                        type="text"
                        name="skill_experienced"
                        className="form-control form-control-sm"
                        placeholder="Experience (Months)"
                        value={editedSkills[skill.id]?.skill_experienced || ""}
                        // onChange={(e) => handleChange(skill.id, e)}
                        onInput={(e) => handleNumberInput(e, (event) => handleChange(skill.id, event), 0, 100)}

                      />
                      {errors[`${skill.id}_skill_experienced`] && (
                        <div className="text-danger">
                          {errors[`${skill.id}_skill_experienced`]}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Rating (1-10)</Label>
                      <Select
                        options={ratingOptions}
                        onChange={(selectedOption) =>
                          handleSkillRatingChange(skill.id, selectedOption)
                        }
                        value={editedSkills[skill.id]?.skill_rating || null}
                        placeholder="Select rating"
                      />
                    </FormGroup>{" "}
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Version</Label>
                      <input
                        type="text"
                        name="skill_version"
                        className="form-control form-control-sm"
                        placeholder="Enter version"
                        value={editedSkills[skill.id]?.skill_version || ""}
                        onChange={(e) => handleChange(skill.id, e)}
                        maxLength={10}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Last Used</Label>
                      <Select
                        options={generatePassingYearsOptions(false)}
                        value={editedSkills[skill.id]?.skill_last_used || null}
                        onChange={(selectedOption) =>
                          handleSkillLastUsedChange(skill.id, selectedOption)
                        }
                        placeholder="Select Last Used Year"
                      />
                      {errors[`${skill.id}_skill_last_used`] && (
                        <div className="text-danger">
                          {errors[`${skill.id}_skill_last_used`]}
                        </div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col
                    md="12"
                    className="d-flex justify-content-end align-items-center mt-3"
                  >
                    <Button
                      color="primary"
                      onClick={() => handleSaveClick(skill.id)}
                      className="btn-sm ms-2"
                    >
                      Save
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => handleDeleteClick(skill)}
                      className="btn-sm ms-2"
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
              ))}
            </Fragment>
          ) : (
            <p>No technical skills available</p>
          )}
        </div>

        {profileData.it_skills && profileData.it_skills.length > 0 && (
          <Form className="theme-form mt-3" onSubmit={handleCoreSkillsSubmit}>
            <Row className="d-flex align-items-center">
              <Col md={type !== "view" ? 10 : 12}>
                <FormGroup>
                  <Label>
                    Core Skills
                    <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isMulti
                    options={
                      profileData.it_skills
                        ? profileData.it_skills.map((skill) => ({
                          label: skill.it_skill.label,
                          value: skill.it_skill.value,
                        }))
                        : []
                    }
                    value={formData.core_skills}
                    onChange={handleCoreSkillsChange}
                    onFocus={handleSkillsFocus}
                    onInputChange={handleSkillsInputChange}
                    placeholder="Select skills"
                  />
                  {errors.core_skills && (
                    <small className="text-danger">{errors.core_skills}</small>
                  )}
                </FormGroup>
              </Col>
              {type !== "view" && (
                <Col md={2} className="d-flex align-items-end">
                  <Button
                    disabled={
                      !formData.core_skills ||
                      formData.core_skills.length == 0 ||
                      formData.core_skills.length > 3 ||
                      updateCandidatePrimarySkillReducerData.isLoading
                    }
                    type="submit"
                    color="primary"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingRight: "1rem",
                      paddingLeft: "1rem",
                    }}
                  >
                    Submit
                  </Button>
                </Col>
              )}
            </Row>
            <small>
              <b>Note:</b> Your core skill can be three of your main skills!
            </small>
          </Form>
        )}
      </CardBody>
    </div>
  );
};

export default TechnicalskillsModal;
